if($('.in-kontakty').length){
    $('footer#footer').before($('div[itemprop="about"] iframe'))
}